'use client';

import { useState, useEffect } from 'react';

/**
 * Custom hook để kiểm tra xem thiết bị có phải là mobile hay không
 * @param breakpoint - Điểm breakpoint để xác định mobile (mặc định là 768px)
 * @returns boolean - true nếu là mobile, false nếu không
 */
export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Hàm này chạy trên client, nên window đã được định nghĩa
    const checkIfMobile = () => {
      // Chỉ cập nhật nếu giá trị thay đổi để tránh re-render không cần thiết
      const isCurrentlyMobile = window.innerWidth < breakpoint;
      if (isMobile !== isCurrentlyMobile) {
        setIsMobile(isCurrentlyMobile);
      }
    };

    // Kiểm tra ngay khi component mount (client-side)
    checkIfMobile();

    // Thêm event listener để kiểm tra khi resize window
    window.addEventListener('resize', checkIfMobile);

    // Cleanup event listener khi component unmount
    return () => window.removeEventListener('resize', checkIfMobile);
  }, [breakpoint, isMobile]); // Thêm isMobile vào dependency để tối ưu if check

  return isMobile;
};
